import { assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__grid2d_feature } from '../_enums/ENUM__grid2d_feature';
import { ENUM__workspace_entity } from '../_enums/ENUM__workspace_entity';

export class DTO__entity_with_grid2d extends DTO__database_entity {
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_ENTITY_WITH_GRID2D;

  /*
   * FIELDS
   */

  name!: string; //optional

  user_id_creator!: string;
  workspace_id!: string;

  grid2d_possible_features: ENUM__grid2d_feature[];
  type!: ENUM__workspace_entity;

  /*
   * METHODS
   */
  constructor() {
    super();

    this.grid2d_possible_features = [];
  }

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.user_id_creator);
    assert_string_not_empty(this.workspace_id);

    assert_type_enum(this.type, ENUM__workspace_entity);
  }

  is_grid2d_feature_possible(feature: ENUM__grid2d_feature): boolean {
    return this.grid2d_possible_features.includes(feature);
  }

  is_add_external_image_possible(): boolean {
    return this.is_grid2d_feature_possible(ENUM__grid2d_feature.IMAGE_EXTERNAL__ADD);
  }

  is_add_internal_image_possible(): boolean {
    return this.is_grid2d_feature_possible(ENUM__grid2d_feature.IMAGE_INTERNAL__ADD);
  }
}
